import { FREELANCEBUILDREQUIREMENT } from "../../../ENVIRONMENT";

// api for freelance client build requirement description
async function freepostBuildRequirementDescription(token, data, id) {
  return await fetch(FREELANCEBUILDREQUIREMENT + `/${id}/jobdescription`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${
        token ? token : sessionStorage.getItem("token")
      }`,
    },
    body: JSON.stringify(data),
  });
}

export { freepostBuildRequirementDescription };
